import { AuthenticatedRoute, AuthViewProps, GoogleCallback, UnauthenticatedRoute } from "@homebound/auth-components";
import { Route, Routes as RouterRoutes } from "react-router-dom";
import { SignIn } from "./routes/auth/SignIn";
import { ExpensesAdmin } from "./routes/expenses/ExpensesAdmin";
import { InboxPage } from "./routes/inbox/InboxPage";
import { TradesLayout } from "./routes/libraries/global-options/TradesLayout";
import { NotFound } from "./routes/NotFound";
import { UserProfile } from "./routes/profile/UserProfile";
import { expensesPath, inboxPaths, searchPath, tradesPath } from "./routes/routesDef";
import { SearchPage } from "./routes/search/Search";
export type ProjectRouteProps = { projectId: string };

/**
 * LEGACY ROUTING — flat route tree for URLs handled by `src/App.tsx`.
 *
 * Migrated domains register in `src/routing/Router.tsx` instead; do not duplicate those paths here.
 * See `src/routing/README.md`.
 */
export function Routes({ authProps }: { authProps: AuthViewProps }) {
  return (
    <RouterRoutes>
      <Route element={<UnauthenticatedRoute authProps={authProps} />}>
        <Route path="/signIn" element={<SignIn {...authProps} />} />
        <Route path="/auth/gcallback" element={<GoogleCallback />} />
      </Route>

      <Route element={<AuthenticatedRoute authProps={authProps} />}>
        <Route path="/profile" element={<UserProfile {...authProps} />} />
        {/* `/projects/:projectId/*` and release-to-trades: data router — see `src/routing/domains/projects.ts` */}
        {/* `/developments`, `/developments/:developmentId/*`, cost-mapping, and development-commitments:
            data router — see `src/routing/domains/developments/`. */}
        <Route path={`${inboxPaths.base}/*`} element={<InboxPage />} />
        {/* `/`, `/personal-dashboard/*`, and `/my-blueprint/*` are served by the data router (src/routing/domains/personalDashboard.tsx). */}
        {/* Finances (`/bills`, `/invoices`, `/purchase-orders`, `/invoice-terms`, `/lien-waivers`) is served by the data router (src/routing/domains/finances.ts). */}
        {/* `/admin/*` (including `/admin/tradeCategories`) is served by the data router (src/routing/domains/admin.tsx). */}
        {/* `/trade-partners/*` is served by the data router (src/routing/domains/tradePartners.ts). */}
        {/* `/trades/bid-packages/*` is served by the data router (src/routing/domains/bidPackages.ts). */}
        <Route path={`${tradesPath}/*`} element={<TradesLayout />} />
        {/* `/libraries/*` is served by the data router (`src/routing/domains/libraries/`). */}
        {/* `/change-log/*` is served by the data router (src/routing/domains/changeLog.ts). */}
        <Route path={expensesPath} element={<ExpensesAdmin />} />
        <Route path={searchPath} element={<SearchPage />} />
        {/* `/warranty/*` is served by the data router (src/routing/domains/warranty.ts). */}
      </Route>

      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
}
